// @flow
import ExchangeModal from './ExchangeModal';

export default ExchangeModal;
